<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">III</h2>
<p class="calibre11">Dumbly frightened at the face of the unknown, Dusty was far more
frightened at being confined in the cabin of his schooner than he was
of the nameless horror he would have to face above. He left the cabin
in a hurry, and with mental desperation he turned deliberately to face
the danger in the hope of getting it over with. He figured there would
be less anguish if it came quickly.</p>
<p class="calibre11">The spacelock door was open wide and a man was standing there with a
fluted-barrelled thing in his hand. On the deck were droplets of copper
still hot enough to send up little wisps of smoke from the deck. The
stub end of the antenna was melted down in a blob. As Dusty looked from
Scyth Radnor to his ruined antenna and back again, Scyth leaned back in
the spacelock and dropped his weapon. Then he made a relaxed show of
sitting on the sill of the airlock with his feet dangling almost to the
tips of the waves. He looked relaxed and calm and the trace of a smile
was on his face; the kind of smile that would open into honest pleasure
if he were greeted with the same.</p>
<div class="figcenter">
<img alt="" class="calibre13" id="id-2797707272099302276" src="Images/img0001.jpg"/>
</div>
<p class="calibre11">"I am sorry," he said. "I am Scyth Radnor of Marandis. Despite the
fact that I was forced to ruin your antenna, I do come on a peaceful
mission, Dusty Britton."</p>
<p class="calibre11">"Yeah—" mumbled Dusty stupidly. Barbara was leaning flat against the
mast, white-faced under her tan.</p>
<p class="calibre11">"Believe me, Dusty. I mean no harm. I did have to prevent you from
broadcasting that which would bring a bad impression of me to your
people."</p>
<p class="calibre11">Scyth reached up and pressed a button in the wall of the spacelock
above his head. The sill of the spacelock came out abruptly in an
extensible runway, carrying Scyth forward over the deck of the
Buccaneer. Scyth dropped to the deck and stood facing Dusty with a hand
extended.</p>
<p class="calibre11">"What do you want?" stammered Dusty. "And how come you talk our
language?"</p>
<p class="calibre11">Scyth pointed to the tiny case slung around his neck. "This is a
menslator," he explained. "When used in direct conversation with a man
of another tongue, it acts to translate for both parties their meaning.
It isn't perfect by any means, but it does help to make people of
different tongues understand one another." Scyth smiled and then said,
"For a quick and amusing explanation, observe this." Scyth clicked the
switch off and began to speak. His speech was utterly comprehensible to
Dusty and Barbara at first, but Scyth clicked the little switch after
he had said a few words. They heard Scyth like this:</p>
<p class="calibre11">"<i class="calibre12">Fa d snall id</i>, an expression meaning to consign to the region of
theological punishment, which when repeated through the menslator
becomes 'Go to hell!' See?"</p>
<p class="calibre11">Dusty nodded dumbly. Barbara relaxed slightly.</p>
<p class="calibre11">"Now," said Scyth, "I am from Marandis. Marandis is a planet only a few
thousand light-years from the Galactic Center, which makes it nearly
thirty thousand light-years from here. Marandis is the seat of the
Galactic Government. Look, Dusty, I came here to explain all this to
you. There is a lot to say, and there is a lot you must take on faith
until you know all of it. Let's relax. Will you come aboard my ship and
have a drink? It's comfortable there and—"</p>
<p class="calibre11">"No!" snapped Dusty.</p>
<p class="calibre11">"Why not?"</p>
<p class="calibre11">"Nobody, but nobody, is going to get me in any space ship," said Dusty
positively.</p>
<p class="calibre11">Scyth eyed Dusty queerly. His thoughts would have been obvious to
anybody but Dusty and Barbara. Scyth was trying to justify in his own
mind the attitude of a High Brass in The Space Patrol (<i class="calibre12">any</i> space
patrol) who would not enter a spacecraft. Scyth finally decided that
Dusty's reticence was due to Dusty's suspicious nature. Dusty was
unarmed and he was not getting into a spacecraft capable of carrying
him across the galaxy, perhaps operated by other members of the crew.
There were no other members, but the ship was big enough to have many.
Scyth nodded to himself and smiled at Dusty.</p>
<p class="calibre11">"As you prefer. I only repeat that I mean no harm and I add that the
salon inside is pleasant. We can all have a—"</p>
<p class="calibre11">"We've got a drink," blurted Dusty. He turned on his heel and got the
quart from the seat by the helm. He stopped to get a third glass. He
poured.</p>
<p class="calibre11">Scyth tasted gingerly. "Very smooth," he said. "What is it?"</p>
<p class="calibre11">"Bourbon."</p>
<p class="calibre11">"Bourbon. Tastes like an excellent liquor. Thank you. Now—" Scyth sat
down on the edge of the deck with his feet hanging into the cockpit
and settled himself for a session. "Dusty, we are here because we are
creating a beacon for our galactic spacelanes."</p>
<p class="calibre11">"Beacon?"</p>
<p class="calibre11">Scyth nodded. "You have the insular viewpoint," he remarked. "You can
stand at night and point out your destination. But you cannot even see
Marandis from here, even with the finest telescope ever built. Stars
lie in the way, huge gas fields and nebular clouds block fast direct
passage. To chart our course safely past such stellar menaces, we
establish beacons at the ends of certain free passages. For instance,
Sol lies at the end of a fifteen hundred light year straightaway from
the last beacon we set up. Here at Sol a slight turn in the course
is made and there is another straightaway for a thousand light-years
toward the Spiral Cluster. We—my friends and I—are charting the
course through a rather interesting rift from Marandis to the Spiral
Cluster. This rift, along which you lie, has been hidden from us for
thousands of years. When it is finished it will cut hours from our
travel-time."</p>
<p class="calibre11">"And maybe so. But what is a beacon and how do you establish it?"</p>
<p class="calibre11">"Dusty, when a spacecraft is running at fifteen hundred light-years
per hour, a three-day-variable star winks in the sky ahead like a
blinker-light." Scyth chopped his left palm rapidly with the edge
of his right hand. "Wink-wink-wink it goes. And the pilot puts his
spacecraft point-of-drive on the beacon and holds it there until he
passes it and aims to the next. You—"</p>
<p class="calibre11">"Variable star!" blurted Dusty.</p>
<p class="calibre11">"Yes. The three-day variables are used for course markers; the longer
variables are used to denote gas fields, nebular dust, and the like,
and the still-longer beacons are used to denote places where various
well-travelled starlanes meet, cross or merge. It is—"</p>
<p class="calibre11">"Three day variable—" breathed Dusty.</p>
<p class="calibre11">"Yes. In three days Sol will rise ten times its present brightness and
fall again to less than one tenth of the present brightness. This is
accomplished by creating an atomic instab—"</p>
<p class="calibre11">"My God! How can any race live under such conditions?"</p>
<p class="calibre11">"They cannot. Not unless properly prepared, well taken care of, aware
and ready for it."</p>
<p class="calibre11">"Look," snapped Dusty. "Why not go out and use some other star for your
damned beacon?"</p>
<p class="calibre11">Scyth shook his head. "If we were gods," he said quietly, "we could
park the Galaxy on our desk, pick up a broom-straw and by fitting and
trying we could locate the best course through the star-fields. But—"</p>
<p class="calibre11">"If you were gods," grunted Dusty bitterly, "you could reach in and
move a few stars aside and run your damned channel on a dead line from
one end to the other. So why do you use Sol?"</p>
<p class="calibre11">"Because the two straightaway lanes that meet at Sol do not meet at
some other star. In one or two cases along this rift the original
surveyors provided alternates in case we ran into trouble. But not on
this one. No, Dusty, we cannot change our plans."</p>
<p class="calibre11">"But see here—"</p>
<p class="calibre11">"Dusty, you wouldn't stand in the way of Galactic Civilization, would
you?"</p>
<p class="calibre11">"You're damn well tootin' I would if it's going to mow me down if I
don't."</p>
<p class="calibre11">Scyth said soothingly, "Doubtless you have cases on your Earth where a
state highway is surveyed right through someone's home. Tell me, Dusty,
what happens then?"</p>
<p class="calibre11">"We buy the property at a fair price so that the family can find
another home of the same value."</p>
<p class="calibre11">"So you don't stand like a barrier in the way of advancement."</p>
<p class="calibre11">"No we don't. But where are we—" Dusty eyed Scyth with a frown.
"You're not going to tell me that your gang will migrate the people of
Earth to another solar system, lock, stock and barrel?"</p>
<p class="calibre11">"That would be impossible, of course."</p>
<p class="calibre11">Dusty grunted. "So we gotta alternately cook and freeze just so your
outfit can run a goddamned traffic pattern through our living room?"</p>
<p class="calibre11">"Well, now, it's not that bad," said Scyth placatingly.</p>
<p class="calibre11">Dusty did not hear the Marandanian. He was thinking of Los Angeles
suffering under the effects of a variable star. Or, rather, he was
trying to visualize such a condition. His imagination provided
alternating scenes of icy blast and deadly heat, but Dusty's overall
technical knowledge was far too meager to offer him even a slight
glimpse of the real truth. To merely consider Sol varying about one
hundred to one in brightness and warmth every three days was as far as
Dusty could go. What would happen to the weather, the general climate,
agriculture, and all of the rest were far beyond Dusty.</p>
<p class="calibre11">Even so, the sketchy picture provided Dusty with enough data to say,
"Why, we couldn't go on living on Earth at all!"</p>
<p class="calibre11">"Right. Which is why I'm here."</p>
<p class="calibre11">"But you said—"</p>
<p class="calibre11">Scyth smiled confidently. "I'm not here to preside over the death of
your part of our human race," he said. "I—"</p>
<p class="calibre11">"Our part of your human race—?" exploded Dusty.</p>
<p class="calibre11">"Of course," said Scyth in a matter-of-fact tone. "So far as we know,
human life was first spawned on Marandis. About thirty thousand years
ago we became galactic in scope, spreading out, colonizing, expanding,
exploring. Many expeditions left home and were lost. But I'll not
belabor this any more, just accept my word for the following: nowhere
in this galaxy have we found intelligent life that did not spring as an
offshoot of misplaced Marandanian culture."</p>
<p class="calibre11">"How can you be so damned certain?"</p>
<p class="calibre11">"The easiest way is to check the cross fertility. It has always worked,
to date at least," said Scyth, inadvertently letting his eyes slide up
and down the very pleasant sight of Barbara Crandall's body. Barbara
knew Scyth's contemplative look and she reacted as any uninhibited
woman does when some man is measuring her. The deep high breath raised
her breasts and flattened her stomach even though she had no great yen
toward wanton promiscuity.</p>
<p class="calibre11">"I gather, then, that you and your gang are going to do something about
us?" she asked.</p>
<p class="calibre11">"Of course. We have a program for cases like this. Since you cannot
live on a planet rotating about a variable star, we'll move Earth to
another star of the same classification."</p>
<p class="calibre11">"But—" objected Dusty.</p>
<p class="calibre11">Scyth went on as though he had not been interrupted. "We'll set up a
barytrine field around Earth which serves to do two things. A barytrine
field cuts the force of gravity that holds Earth to Sol. It also
produces a complete stoppage of objective and subjective time within
the field. Then with machinus force-fields we'll put Earth in motion
towards another star of Sol's general size. In a thousand years you'll
come out of the barytrine field and resume your daily lives under the
light of a brand-new sun. It's as simple as that."</p>
<p class="calibre11">Dusty eyed Scyth sourly. "Maybe I've got this wrong," he said. "Maybe
you think we live a hell of a lot longer than we do. Maybe you live a
thousand years and more but we—"</p>
<p class="calibre11">Scyth held up a hand. It was the hand that held the glass, which was
empty. Dusty, reacting as he always did to the sight of an empty glass,
filled it despite the fact that he felt that Scyth Radnor was a long
way from being a friend.</p>
<p class="calibre11">The visitor from space smiled indulgently. "You miss the point,
Dusty," said Scyth, nodding his thanks for the drink. "I said that
the barytrine field produces a complete stasis in time. It will snap
on ... a thousand years will pass ... it will snap off. To us, we will
live and die and never see you again. But for you and yours, if you
drop a marble before the field goes on, time will cease for you until
the field goes off, and your marble will hit the floor a thousand years
from now. You will feel nothing. There will be a tiny flick of light.
If you are watching the sun it will probably blink and return slightly
off-center because we never can be that precise. If you are watching
the stars at night, they will wink out and wink on, and be in a new
pattern. You will feel nothing."</p>
<p class="calibre11">"Yes, but, look here, we—"</p>
<p class="calibre11">Scyth smiled again. "Oh, you'll be repaid. We'll raise you from your
present primitive level—"</p>
<p class="calibre11">"Primitive?"</p>
<p class="calibre11">Scyth nodded. "Primitive," he said. "You're as primitive to us as your
savages are to you."</p>
<p class="calibre11">"But—"</p>
<p class="calibre11">"Look, Dusty, thirty thousand years ago, Marandis was still ahead of
your present state of development. I can say this because your people
at the present time still have no inkling as to the inconsistencies
in the theory of general relativity. Someday soon you will discover
that general relativity does not fit all the cases. Then you will
propose the machinus theory of space-time. The machinus theory works
where relativity does not. Then," glowed Scyth, "you will discover
the phanoband carriers which operate in a way as to completely deny
relativity in every concept. From there you find the barytrine field
forces. But you're still primitive, Dusty."</p>
<p class="calibre11">Dusty eyed the Marandanian sourly.</p>
<p class="calibre11">Scyth continued, "You'd find little in common with us," he said. "You'd
find that you would have to re-educate yourself before you could even
understand us. Why, there are people in our culture who would take
advantage of your ignorance."</p>
<p class="calibre11">Dusty nodded. His hazy knowledge of history presented him with a
costume drama of Sir Walter Raleigh handing over a ten, two fives, and
four ones to Chief Sitting Bull and receiving in return an engraved
bill of sale for the Island of Manhattan. This negotiation was sealed
with a slug of liquor out of a bottle labeled 'Bourbon, Bottled in
Kentucky.' (Pocahontas, standing to one side, received a string of
beads.)</p>
<p class="calibre11">Scyth went on:</p>
<p class="calibre11">"The big problem, Dusty, so far as you are concerned is the preparation
of your people. We cannot be precise about the position of the new
sun. We could not possibly hope to keep any semblance of your stellar
geography. When the barytrine field goes on, it will produce an effect
similar to reaching the splice in a reel of film. With no warning,
no pain, strain, nor furor the sun will snap slightly aside to its
new position. On the night-side the stars will flick instantly to a
new pattern. This sort of change would cause great hysteria and fear.
Unless the people are prepared for the sudden change. So, Dusty, you
as a high official in your Space Patrol must carry our message to your
people."</p>
<p class="calibre11">Dusty said, "But—"</p>
<p class="calibre11">"You've mentioned the possibility of payment," said Scyth smoothly.
"We expect and intend to pay. But not in money, Dusty. In service
and commerce and in many other ways. For instance, we know that your
group—I cannot call it your 'race' because your race is ours—must
stem from an early expedition and so you are a lost offshoot. As soon
as we can, we will come to you with teachers and learned men to help
you regain your rightful place as a part of our Galactic Culture."</p>
<p class="calibre11">Dusty looked at Scyth. In his mind churned a hundred objections to the
whole thing. He did not like it at all, but he was logical enough to
realize that his objections would be waved aside and the Marandanians
would go on and do as they planned anyway. On the other hand, maybe if
Dusty Britton were to take a large hand in this affair and carry it off
successfully, Dusty Britton could become a large figure indeed.</p>
<p class="calibre11">"It will be a bit difficult," he said slowly. "People are not going to
take to the idea of losing their sky and sun and a thousand years out
of the middle of their lives."</p>
<p class="calibre11">"The thousand years are peanuts. Nobody will notice it. The swap in
suns is only a sentimental objection. One sun is like the next and
we'll see to it that they are as close as can be had. The change in
stellar appearance is deplorable, I admit. But it will give you one
advantage, Dusty. Like most skies, they are divided off into primitive
legendary shapes with neither rhyme nor reason. A cluttered mess. With
a fresh start you can make some reason to the constellations. These
are the sort of arguments you must use, Dusty. As a final reminder,
you must remember that this is what is going to be done. Period. It
is necessary and it cannot be stopped. Therefore you and your people
should accept it and make the best of it. Therefore, in what will seem
like three weeks, you will be by another star, under a strange sky, a
thousand years from this moment. And my people will be there waiting to
help you on your climb to the pinnacle of culture.</p>
<p class="calibre11">"But now I must go. Take my words back to your leaders, Dusty. You will
go down in history; make the best of it!"</p>
<p class="calibre11">As abruptly as that—Scyth Radnor arose from the deck of the Buccaneer,
climbed onto his runway, and was drawn back into the big spacecraft.
The spacelock closed smoothly and the huge ship rose silently out of
the sea and arrowed towards the high blue sky. The only noise was the
whistle of its passage through the air above.</p>
<p class="calibre11">Scyth landed beside the bubble on Mercury's dark side not long after.
Chat greeted him with a question about his success and Scyth smiled.
"Naturally they didn't cotton to it," he said. "No one ever would."</p>
<p class="calibre11">Chat nodded agreement. "They wouldn't stand in the path of advancement,
would they?"</p>
<p class="calibre11">Scyth chuckled. "I'm getting to be something of a diplomat," he said.
"Not good, but I think adequate."</p>
<p class="calibre11">"Yes?"</p>
<p class="calibre11">"Sure. First I told them about the beacon and let them ask questions
about it to whet their curiosity. Then I explained what the beacon
was, which horrified them completely, as it should. Then after letting
them cook in their own fright for some time I let them down easy by
explaining how we would help to save them. So now there's nothing to do
but to finish off the job."</p>
<p class="calibre11">"Right. How long will it take for you to get the barytrine generator
set up and ticking?"</p>
<p class="calibre11">"Call it a couple of weeks. I'll have to go back to Marandis for the
generator. It may take me a day or two to get it, you know. We'll
have to get our license revised, and we'll have to put a bond against
the safety of this planet Earth, as they call it. Of course, we'll
have lots of time to look for another sun where we can put their
planet; we can do that after the beacon is started and they're out of
danger-distance."</p>
<p class="calibre11">Bren said, "So the first thing for you to do is to hike back to
Marandis and get your barytrine generator."</p>
<p class="calibre11">Chat added, "When you take off from here, be sure you go due North
until you're a long way out of line. No use in advertising our
position."</p>
<p class="calibre11">"Right. I'll fog-off the course as best I can."</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?0f40780e